import Vue from 'vue'
import axios from 'axios'

const state = {
  isFetching: false,
  isMore: true,
  limit: 8,
  professional: null,
  professionals: null,
  recommendProfessionals: null,
  professionalEarningsData: null,
  professionalBonusData: null,
  hasPaidOrder: false
}

const actions = {
  LOAD_PROFESSIONAL_LIST: ({ commit }, queryData) => {
    const url = 'professionals'
    Vue.http.get(url, { params: queryData })
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          commit('SET_PROFESSIONAL_LIST', response.professionals)
        }
      })
  },
  LOAD_PROFESSIONAL_DETAIL: async ({ commit }, queryData) => {
    commit('SET_IS_FETCHING', true)
    const url = 'professionals/' + queryData.professional_id
    const { data } = await axios.get(url, { params: queryData })
    commit('SET_IS_FETCHING', false)
    if (!data.error) {
      commit('SET_HAS_PAID_ORDER', data.has_paid_order)
      commit('SET_PROFESSIONAL_DETAIL', data.professional)
    }
  },
  LOAD_RECOMMEND_PROFESSIONAL_LIST: ({ commit }, queryData) => {
    commit('SET_IS_FETCHING', true)
    const url = 'bookings/recommend-professionals'
    Vue.http.get(url, { params: queryData })
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_FETCHING', false)
        if (!response.error) {
          (queryData.page > 0) ? commit('ADD_RECOMMEND_PROFESSIONAL_LIST', response.professionals) : commit('SET_RECOMMEND_PROFESSIONAL_LIST', response.professionals)
        } else {
          commit('SET_NO_DATA')
          if (queryData.page === 0) {
            commit('SET_RECOMMEND_PROFESSIONAL_LIST', [])
          }
        }
      })
  },
  LOAD_PROFESSIONAL_EARNING_LIST: ({ commit }, queryData) => {
    commit('SET_IS_FETCHING', true)
    const url = 'professionals/' + queryData.professional_id + '/earnings'
    Vue.http.get(url, { params: queryData })
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_FETCHING', false)
        if (!response.error) {
          commit('SET_PROFESSIONAL_EARNINGS_DATA', response)
        }
      })
  },
  LOAD_PROFESSIONAL_BONUS: ({ commit }, payload) => {
    commit('SET_IS_FETCHING', true)
    let queryData = payload.queryData
    let callback = payload.callback
    const url = 'professionals/' + queryData.professional_id + '/bonus-stats'
    Vue.http.get(url, { params: queryData })
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_FETCHING', false)
        if (!response.error) {
          commit('SET_PROFESSIONAL_BONUS_DATA', response)
        }
        if (callback) {
          callback()
        }
      })
  }
}

const mutations = {
  SET_IS_FETCHING: (state, status) => {
    state.isFetching = status
  },
  SET_PROFESSIONAL_DETAIL: (state, professional) => {
    state.professional = professional
  },
  UPDATE_FAVORITE_PROFESSIONAL: (state, status) => {
    state.professional.is_favorited_professional = status
  },
  SET_RECOMMEND_PROFESSIONAL_LIST: (state, professionals) => {
    state.recommendProfessionals = professionals
    state.isFetching = false
    state.isMore = true
    if (professionals.length < state.limit) {
      state.isMore = false
    }
  },
  ADD_RECOMMEND_PROFESSIONAL_LIST: (state, professionals) => {
    state.isFetching = false
    state.isMore = true
    for (let key in professionals) {
      state.recommendProfessionals.push(professionals[key])
    }
    if (professionals && professionals.length < state.limit) {
      state.isMore = false
    }
  },
  SET_PROFESSIONAL_EARNINGS_DATA: (state, data) => {
    state.professionalEarningsData = data
  },
  SET_PROFESSIONAL_BONUS_DATA: (state, data) => {
    state.professionalBonusData = data
  },
  SET_PROFESSIONAL_LIST: (state, professionals) => {
    state.professionals = professionals
  },
  SET_HAS_PAID_ORDER: (state, hasPaidOrder) => {
    state.hasPaidOrder = hasPaidOrder
  }
}

const getters = {
  getState: state => {
    return state
  },
  getProfessional: state => {
    return state.professional
  },
  getProfessionals: state => {
    return state.professionals
  },
  getRecommendProfessionals: state => {
    return state.recommendProfessionals
  },
  getIsMore: state => {
    return state.isMore
  },
  isLoadMore: state => {
    return state.isFetching ? 'message.button.loading' : 'message.button.load_more'
  },
  getProfessionalEarnings: state => {
    return state.professionalEarningsData
  },
  getProfessionalBonuses: state => {
    return state.professionalBonusData
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/professional.js